import { useQuery } from "@tanstack/react-query";
import { fetchErrorLogs } from "./errorlogs.api";
import { keys } from "./keys";

export const useErrorLogsQuery = (params) => {
    return useQuery({
        queryKey: keys.errorLogs.list(params),
        queryFn: () => fetchErrorLogs(params),
        placeholderData: (prev) => prev
    });
};
